import React, { useEffect, useState } from "react";
import "./Forms.css";
import { Container, Button, Card, Col, Row, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { AssignFormToApplicant, GetCustomerForms } from "../../apis/FormAPI";
import * as BsIcons from "react-icons/bs";
import { useAlert } from "react-alert";
import Loader from "../../components/Loader";
import { useSelector } from "react-redux";

export default function CreditApplicationForm() {
  const {user} = useSelector((state) => state.auth);
  const [applicantName, setApplicantName] = useState("");
  const [applicantAddress, setApplicantAddress] = useState("");
  const [applicantEmail, setApplicantEmail] = useState("");
  const [applicantNote, setApplicantNote] = useState("");
  const [requireSign, setRequireSign] = useState(false);
  const [applicationList, setApplicationList] = useState([]);
  const defaultForm = {
    formName: "Choose Credit Application...",
    formTemplateId: "0",
  };
  const [creditApplication, setCreditApplication] = useState(defaultForm);

  const [validated, setValidated] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  // const [showWrongUser, setShowWrongUser] = useState(false);
  const navigate = useNavigate();
  const alert = useAlert();

  useEffect(() => {
    async function GetCreditForms() {
      var result = await GetCustomerForms(user.customerid);
      var data = result.data;
      if (data.length > 0) {
        setApplicationList(data);
      }
    }
    GetCreditForms();
  }, []);

  const sendApplication = async (event) => {
    document.getElementById("btnSubmit").disabled = true;
    var validRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

    setValidated(true);
    if (
      applicantEmail != undefined &&
      applicantEmail != null &&
      applicantEmail.match(validRegex)
    ) {
      var reqBody = {
        id: 0,
        totalRows: 0,
        formTemplateId: creditApplication.formTemplateId,
        customerId: user.customerid,
        userId: user.userid,
        orderId: 0,
        applicantName: applicantName,
        applicantAddress: applicantAddress,
        applicantEmail: applicantEmail,
        requireSignature: requireSign,
        applicantNotes: applicantNote,
        formData: JSON.stringify([]),
        formStatusId: 0,
        formStatusName: "",
        token: "",
      };

      setShowLoader(true);
      var result = await AssignFormToApplicant(reqBody);

      if (result.status === 200) {
        document.getElementById("btnSubmit").disabled = false;
        alert.success("Email sent to applicant with form link.", {
          onClose: () => {
            navigate("/Customer/Forms");
          },
        });
      } else {
        alert.error("Error! Unable to assing form to applicant", {
          onClose: () => setShowLoader(false),
        });
        document.getElementById("btnSubmit").disabled = false;
      }
    } else {
      alert.error("Enter valid email address");
      document.getElementById("btnSubmit").disabled = false;
    }
  };

  return (
    <>
      <Container className="mb-5">
        <Row className="page-head-row">
          <Col lg={6} md={6} sm={12}>
            <div className="page-title">
              <h2>Send a Form to an Applicant</h2>
            </div>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <div className="search-filter"></div>
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            <Card className="orderdetails-card form-other-pages">
              <div className="card-head">
                <div className="card-title h5">Credit Application Details </div>
                <Link to="/Customer/Forms" className="back-btn">
                  <BsIcons.BsArrowLeft />
                </Link>
              </div>
              <Form noValidate validated={validated}>
                <Row>
                  <Col lg={12} md={12}>
                    <div className="orderdetails-info credit-application-form">
                      <div className="orderdetails-info-list">
                        <span>Applicant Name:</span>
                        <Form.Group className="" controlId="ApplicantName">
                          <Form.Control
                            type="text"
                            required
                            value={applicantName}
                            onChange={(e) => setApplicantName(e.target.value)}
                          />
                        </Form.Group>
                      </div>
                      <div className="orderdetails-info-list">
                        <span>Applicant Address:</span>
                        <Form.Group className="" controlId="ApplicantAddress">
                          <Form.Control
                            type="text"
                            required
                            value={applicantAddress}
                            onChange={(e) =>
                              setApplicantAddress(e.target.value)
                            }
                          />
                        </Form.Group>
                      </div>
                      <div className="orderdetails-info-list">
                        <span>Applicant Email:</span>
                        <Form.Group
                          className=""
                          controlId="ApplicantEmail"
                          value={applicantEmail}
                          onChange={(e) => setApplicantEmail(e.target.value)}
                        >
                          <Form.Control
                            type="email"
                            pattern="/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/"
                            required={true}
                          />
                        </Form.Group>
                      </div>
                      <div className="orderdetails-info-list">
                        <span>Credit Application:</span>
                        <DropDownList
                          className="form-control custom-form-control-select"
                          data={applicationList}
                          textField="formName"
                          dataItemKey="formTemplateId"
                          defaultItem={defaultForm}
                          value={creditApplication}
                          onChange={(e) => setCreditApplication(e.target.value)}
                        />
                      </div>
                      <div className="orderdetails-info-list">
                        <span>Require eSignature?:</span>
                        <div className="billing-info">
                          <Form.Check
                            aria-label="option 1"
                            defaultChecked={requireSign}
                            onChange={(e) => setRequireSign(e.target.checked)}
                          />
                        </div>
                      </div>
                      <div className="orderdetails-info-list">
                        <span>Notes for Applicant:</span>
                        <Form.Group className="mb-3" controlId="NotesApplicant">
                          <Form.Control
                            as="textarea"
                            required
                            rows={3}
                            value={applicantNote}
                            onChange={(e) => setApplicantNote(e.target.value)}
                          />
                        </Form.Group>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col className="text-center mt-5">
                    <Button
                      id="btnSubmit"
                      type="button"
                      className="view-report-btn"
                      onClick={sendApplication}
                    >
                      Send Credit Application to Applicant
                      <Loader visible={showLoader} ibutton={true} />
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
